import { ComponentLocationStrategy } from './component-location-strategy';
import { Injectable } from '@angular/core';

@Injectable()
export class StandardrechtLocationStrategy extends ComponentLocationStrategy {
  componentId(): string {
    return 'STANDARDRECHT';
  }
}
